/**
 * Scale factor for the html2canvas report thumbnail. The thumbnail is only
 * shown ~100px wide in the reports list, but a full-resolution PNG of a
 * photo-heavy report blows past Firestore's ~1MB field limit. Capturing at
 * a fixed target width keeps the Thumbnail field small no matter how large
 * the report canvas is.
 *
 * @param {number} [elementWidth] - Rendered width of the report canvas in px.
 * @param {number} [targetWidth=600] - Desired thumbnail width in px.
 * @returns {number} html2canvas `scale` value, capped at 1 (never upscale).
 */
const computeThumbnailScale = (elementWidth, targetWidth = 600) => {
    if (!elementWidth || elementWidth <= 0) return 1;
    return Math.min(1, targetWidth / elementWidth);
};

export default computeThumbnailScale;
